const splitNumber = (number: any) => {
  number = number.toString().split(".");
  const front = number[0];
  const behind = number[1] ? "." + number[1].slice(0, 2) : "";
  return front + behind;
};
export default splitNumber;
